import { render, staticRenderFns } from "./CategoriesUpdate.vue?vue&type=template&id=cf75e5ce&scoped=true&"
import script from "./CategoriesUpdate.vue?vue&type=script&lang=js&"
export * from "./CategoriesUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf75e5ce",
  null
  
)

export default component.exports